import {kHomeTexts} from "../../../constants/texts";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";

export default function HomeDownloadMobileAppTexts() {
    // Used in HomeDownloadMobileApp to display related texts

    // BUILD
    return (
        <div className={"flex flex-col space-y-[24px] justify-start items-start"}>
            <span className={"text-[36px] font-bold text-white leading-none"}>
                {kHomeTexts.downloadTitle}
            </span>
            <span className={"font-normal text-[16px] text-greyLight9"}>
                {aboutScreenHighlightWords(kHomeTexts.downloadContent, ['chaque moment', 'besoin', 'Android', 'iOS'])}
            </span>
        </div>
    );
}